import { render } from "./LoginForm.vue?vue&type=template&id=dbc49e0a&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=dbc49e0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dbc49e0a"

export default script